import { render, staticRenderFns } from "./GlobalWindow.vue?vue&type=template&id=9b066f2a&scoped=true"
import script from "./GlobalWindow.vue?vue&type=script&lang=js"
export * from "./GlobalWindow.vue?vue&type=script&lang=js"
import style0 from "./GlobalWindow.vue?vue&type=style&index=0&id=9b066f2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b066f2a",
  null
  
)

export default component.exports